<template>
  <div class="dealt-with" v-if="doItemsObj">
    <div class="tit1">待办事项类型</div>
    <div class="event-stat" >
      <p><span>{{doItemsObj.dhSendGoodsNum}}</span><br />订货待发货数量</p>
      <p><span class="gr">{{doItemsObj.businessAuditNum}}</span><br />业务审核</p>
      <p><span class="gr">{{doItemsObj.customerAuditNum}}</span><br />客户审核</p>
      <p><span class="gr">{{doItemsObj.certificatesNum}}</span><br />待认证审核</p>
      <p><span>{{doItemsObj.skillSendGoodsNum}}</span><br />秒杀待发货数量</p>
      <p><span>{{doItemsObj.integralSendGoodsNum}}</span><br />积分待发货数量</p>
      <p><span class="bl">{{doItemsObj.processingOrderAfterNum}}</span><br />待处理售后数量</p>

    </div>
  </div>
</template>

<script>
import homeStatisticsApi from '@/api/home'
export default {
  data() {
    return {
      doItemsObj: null,   //待办事项
    }
  },
  created() {
    this.getStatistics()
  },
  methods: {
    getStatistics() {
      homeStatisticsApi.findHomeToDoList().then(res => {
        this.doItemsObj = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-box {
  margin-top: 20px;
  padding: 16px;
  border: 1px solid #3a8ee6;
  background: rgba(58, 142, 230, 0.1);
  border-radius: 6px;
  .grid-title {
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .grid-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-size: 16px;
      text-align: center;
      line-height: 22px;
      position: relative;
      &:first-child {
        color: #3a8ee6;
      }
    }
  }
  &.grid-box1 {
    border-color: #e55c17;
    background: rgba(229, 92, 23, 0.1);
    .grid-content {
      p {
        &:first-child {
          color: #e55c17;
        }
      }
    }
  }
  &.grid-box2 {
    border-color: #f2a200;
    background: rgba(242, 162, 0, 0.1);
    .grid-content {
      p {
        &:first-child {
          color: #f2a200;
        }
      }
    }
  }
}
.dealt-with {
  .tit1 {
    font-size: 16px;
    padding-bottom: 20px;
  }
  .node-cont {
    display: flex;
    align-items: center;
    background: #fafafa;
    margin-top: 30px;
    padding: 10px 24px;
    .el-progress {
      margin-right: 16px;
    }
    p {
      font-size: 14px;
      color: #999999;
      text-align: center;
      margin-right: 80px;
      line-height: 22px;
      &:last-child {
        margin-right: 0;
      }
      span {
        color: #000;
        font-size: 18px;
      }
      &.first-p {
        color: #f2a200;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          right: -40px;
          top: 10px;
          bottom: 10px;
          width: 1px;
          background: #e5e4e4;
        }
        span {
          font-size: 24px;
          color: #f2a200;
        }
      }
    }
  }
  .event-stat {
    display: flex;
    flex-wrap: wrap;
    // justify-self: flex-end;
    p {
      font-size: 16px;
      color: #666666;
      background: #fff;
      width: 200px;
      height: 100px;
      margin: 0 20px 20px 0;
      border-radius: 4px;
      padding-left: 10px;
      padding-top: 10px;
      box-sizing: border-box;
      line-height: 22px;
      span {
        color: #000;
        position: relative;
        padding-left: 15px;
        display: flex;
        align-items: center;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #f2a200;
        }
        &.bl {
          &::before {
            background: #3a8ee6;
          }
        }
        &.gr {
          &::before {
            background: #00c884;
          }
        }
      }
    }
  }
}
.progress-box {
  padding: 25px 20px;
  margin-top: 20px;
  background: #fafafa;
  border-radius: 6px;

  .tit2 {
    font-size: 20px;
  }
  .prog-cont {
    margin-top: 30px;
    display: flex;
    .prog-item {
      width: 48%;
      display: flex;
      align-items: center;

      p {
        font-size: 14px;
        display: inline-block;
        padding-left: 20px;
        line-height: 20px;
        span {
          color: #999;
        }
      }
    }
  }
}
.el-link {
  padding-right: 20px;
}
</style>